export default {
    noResultsText: 'Ningún resultado encontrado',
    searching: 'Buscando...',
    minDigits: 'Por Favor introduzca al menos 3 caracteres',
}
